import { useContext, useEffect, useState } from "react";
import {
	defaultIconVariant,
	defaultThemeVariant,
	iconVariantsConfig,
} from "config-txp";
import { Context } from "Context";
import { getThemeKey, isNavFloat, isNavGradient } from "utils/txp";

export const useIconButtonVariant = ({
	toggle = false,
	isScrolling = false,
	brand,
}) => {
	const {
		config: { isTxp },
		isSticky,
	} = useContext(Context);

	const [iconVariant, setIconVariant] = useState(defaultIconVariant);
	const themeVariant = getThemeKey(isTxp) || defaultThemeVariant;

	useEffect(() => {
		let viewConfig = "default";
		const isGradient = isNavGradient();
		if (isGradient && isSticky) {
			viewConfig = "navGradientSticky";
		} else if (isGradient) {
			viewConfig = "navGradient";
		} else if (isNavFloat()) {
			viewConfig = "navFloat";
		}

		const caseConfig = isScrolling ? "scroll" : toggle ? "open" : "default";
		const variantConfig =
			iconVariantsConfig?.[themeVariant]?.[brand] ||
			iconVariantsConfig?.[themeVariant]?.base;
		const variant =
			variantConfig?.[viewConfig]?.[caseConfig] || defaultIconVariant;

		setIconVariant(variant);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [toggle, isScrolling]);

	return iconVariant;
};
